import React, { Suspense } from 'react';
import {
    FullScreen,
    HeaderBlock,
    ContentBlock
} from './style'

import TitleHeader from 'components/presenters/header/TitleHeader'; 
import LoadingModal from 'components/presenters/modal/LoadingModal';

const PrivatePolicyModal = ({visible, onClose}) => {
    if(!visible) return null;
    const PrivatePolicy = React.lazy(() => import('components/containers/mypage/PrivatePolicy'));
    return(
        <FullScreen>
            <HeaderBlock>
                <TitleHeader onBackBtn={onClose} title={'개인정보 수집방침'}/>
            </HeaderBlock>
            <ContentBlock> 
                <Suspense fallback={<LoadingModal zIndex={500}/>}>
                    <PrivatePolicy />
                </Suspense>
            </ContentBlock>
        </FullScreen>
    );
}

export default PrivatePolicyModal;